import { useState } from "react";

export const useFilesToSend = () => {
  //selecionar itens que não vão ser enviados
  const [fileToSend, setFileToSend] = useState(null);
  const addFileInFilesToSend = (fileId) => {
    setFileToSend(fileId);
  };

  const clearFilesToSend = () => {
    setFileToSend(null);
  };

  const handleCheckToAddFiles = (e, id_conteudo) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      addFileInFilesToSend(id_conteudo);
    } else {
      clearFilesToSend();
    }
  };

  return {
    fileToSend,
    clearFilesToSend,
    handleCheckToAddFiles,
  };
};
